import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import {
	Button,
	ButtonGroup,
	Divider,
	Grid,
	ListItemButton,
	ListItemIcon,
	Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import axios from "axios";
import Swal from "sweetalert2";

const ExtraOptions = ({ data: savedData, id, token, handleClose }) => {
	const [passengersCount, setPassengersCount] = React.useState(
		savedData.passengersCount || 1,
	);
	const [passengers, setPassengers] = React.useState(
		savedData.passengers || true,
	);
	const passengers1 = (event) => {
		setPassengers(event.target.checked);
	};

	const [luggageCount, setLuggageCount] = React.useState(
		savedData.luggageCount || 0,
	);
	const [luggage, setLuggage] = React.useState(savedData.luggage || false);
	const luggage1 = (event) => {
		setLuggage(event.target.checked);
	};

	const [wheelchairCount, setWheelchairCount] = React.useState(
		savedData.wheelchairCount || 0,
	);
	const [wheelchair, setWheelchair] = React.useState(
		savedData.wheelchair || false,
	);
	const wheelchair1 = (event) => {
		setWheelchair(event.target.checked);
	};

	const [babyCount, setBabyCount] = React.useState(savedData.babyCount || 0);
	const [babySeat, setBabySeat] = React.useState(savedData.babySeat || false);
	const babySeat1 = (event) => {
		setBabySeat(event.target.checked);
	};

	const [carSeatCount, setcarSeatCount] = React.useState(
		savedData.carSeatCount || 0,
	);
	const [carSeat, setCarSeat] = React.useState(savedData.carSeat || false);
	const carSeat1 = (event) => {
		setCarSeat(event.target.checked);
	};

	React.useEffect(() => {
		setPassengersCount(savedData.passengersCount || 1);
		setPassengers(savedData.passengers || true);
		setLuggageCount(savedData.luggageCount || 0);
		setLuggage(savedData.luggage || false);
		setWheelchairCount(savedData.wheelchairCount || 0);
		setWheelchair(savedData.wheelchair || false);
		setBabyCount(savedData.babyCount || 0);
		setBabySeat(savedData.babySeat || false);
		setcarSeatCount(savedData.carSeatCount || 0);
		setCarSeat(savedData.carSeat || false);
	}, [savedData]);

	const saveAndGo = () => {
		const data = {
			passengers,
			passengersCount,
			luggage,
			luggageCount,
			wheelchair,
			wheelchairCount,
			babySeat,
			babyCount,
			carSeat,
			carSeatCount,
		};
		axios
			.patch(
				`${process.env.REACT_APP_API_PATH}/bookings/${id}`,
				{
					...data,
				},
				{
					headers: {
						Authorization: token,
					},
				},
			)
			.then((res) => {
				Swal.fire({
					icon: "success",
					title: "Success",
					text: res.data.message,
				});
				handleClose();
			})
			.catch((err) => {
				Swal.fire({
					icon: "error",
					title: "Error",
					text: err.response.data.message,
				});
			});
	};

	return (
		<div className='importantOptions'>
			<ListItemButton
				button
				disableRipple
				disableTouchRipple
				disablefocusribble='true'>
				<Grid container spacing={2} sx={{ alignItems: "center" }}>
					<Grid item md={6} sm={4} xs={12}>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								textAlign: "left",
							}}>
							<Typography variant='h6'>Total Passengers</Typography>
						</Box>
					</Grid>
					<Grid item md={3} sm={4} xs={6}>
						<ButtonGroup>
							<Button
								sx={{ color: "black" }}
								aria-label='reduce'
								onClick={() => {
									setPassengersCount(Math.max(passengersCount - 1, 0));
								}}>
								<RemoveIcon fontSize='small' />
							</Button>
							<Button sx={{ color: "black" }} variant='outlined'>
								{" "}
								{passengersCount}
							</Button>
							<Button
								sx={{ color: "black" }}
								aria-label='increase'
								onClick={() => {
									setPassengersCount(passengersCount + 1);
								}}>
								<AddIcon fontSize='small' />
							</Button>
						</ButtonGroup>
					</Grid>
					<Grid item md={3} sm={4} xs={6}>
						<ListItemIcon>
							<Checkbox
								icon={
									<Button
										style={{ backgroundColor: "transparent" }}
										sx={{
											px: 2,
											py: 1,
											bgcolor: "#EAECEE",
											color: "black",
											fontWeight: "bold",
											border: "1px solid",
										}}
										variant='contained'>
										Select
									</Button>
								}
								checkedIcon={
									<Button
										className='activeButtonColor'
										sx={{ px: 2, py: 1 }}
										variant='contained'>
										<CheckIcon sx={{ mr: 0.7 }} /> Select
									</Button>
								}
								checked={passengers}
								onChange={passengers1}
							/>
						</ListItemIcon>
					</Grid>
				</Grid>
			</ListItemButton>
			<Divider sx={{ my: 1.5 }} />
			<ListItemButton
				button
				disableRipple
				disableTouchRipple
				disablefocusribble='true'>
				<Grid container spacing={2} sx={{ alignItems: "center" }}>
					<Grid item md={6} sm={4} xs={12}>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								textAlign: "left",
							}}>
							<Typography variant='h6'>Total Luggage</Typography>
						</Box>
					</Grid>
					<Grid item md={3} sm={4} xs={6}>
						<ButtonGroup>
							<Button
								sx={{ color: "black" }}
								aria-label='reduce'
								onClick={() => {
									setLuggageCount(Math.max(luggageCount - 1, 0));
								}}>
								<RemoveIcon fontSize='small' />
							</Button>
							<Button sx={{ color: "black" }} variant='outlined'>
								{" "}
								{luggageCount}
							</Button>
							<Button
								sx={{ color: "black" }}
								aria-label='increase'
								onClick={() => {
									setLuggageCount(luggageCount + 1);
								}}>
								<AddIcon fontSize='small' />
							</Button>
						</ButtonGroup>
					</Grid>
					<Grid item md={3} sm={4} xs={6}>
						<ListItemIcon>
							<Checkbox
								icon={
									<Button
										style={{ backgroundColor: "transparent" }}
										sx={{
											px: 2,
											py: 1,
											bgcolor: "#EAECEE",
											color: "black",
											fontWeight: "bold",
											border: "1px solid",
										}}
										variant='contained'>
										Select
									</Button>
								}
								checkedIcon={
									<Button
										className='activeButtonColor'
										sx={{ px: 2, py: 1 }}
										variant='contained'>
										<CheckIcon sx={{ mr: 0.7 }} /> Select
									</Button>
								}
								checked={luggage}
								onChange={luggage1}
							/>
						</ListItemIcon>
					</Grid>
				</Grid>
			</ListItemButton>
			<Divider sx={{ my: 1.5 }} />

			<ListItemButton
				button
				disableRipple
				disableTouchRipple
				disablefocusribble='true'>
				<Grid container spacing={2} sx={{ alignItems: "center" }}>
					<Grid item md={6} sm={4} xs={12}>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								textAlign: "left",
							}}>
							<Typography variant='h6'>Child Seat</Typography>
						</Box>
					</Grid>
					<Grid item md={3} sm={4} xs={6}>
						<ButtonGroup>
							<Button
								sx={{ color: "black" }}
								aria-label='reduce'
								onClick={() => {
									setBabyCount(Math.max(babyCount - 1, 0));
								}}>
								<RemoveIcon fontSize='small' />
							</Button>
							<Button sx={{ color: "black" }} variant='outlined'>
								{" "}
								{babyCount}
							</Button>
							<Button
								sx={{ color: "black" }}
								aria-label='increase'
								onClick={() => {
									setBabyCount(babyCount + 1);
								}}>
								<AddIcon fontSize='small' />
							</Button>
						</ButtonGroup>
					</Grid>
					<Grid item md={3} sm={4} xs={6}>
						<ListItemIcon>
							<Checkbox
								icon={
									<Button
										style={{ backgroundColor: "transparent" }}
										sx={{
											px: 2,
											py: 1,
											bgcolor: "#EAECEE",
											color: "black",
											fontWeight: "bold",
											border: "1px solid",
										}}
										variant='contained'>
										Select
									</Button>
								}
								checkedIcon={
									<Button
										className='activeButtonColor'
										sx={{ px: 2, py: 1 }}
										variant='contained'>
										<CheckIcon sx={{ mr: 0.7 }} /> Select
									</Button>
								}
								checked={babySeat}
								onChange={babySeat1}
							/>
						</ListItemIcon>
					</Grid>
				</Grid>
			</ListItemButton>
			<Divider sx={{ my: 1.5 }} />
			<ListItemButton
				button
				disableRipple
				disableTouchRipple
				disablefocusribble='true'>
				<Grid container spacing={2} sx={{ alignItems: "center" }}>
					<Grid item md={6} sm={4} xs={12}>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								textAlign: "left",
							}}>
							<Typography variant='h6'>Wheel Chair</Typography>
						</Box>
					</Grid>
					<Grid item md={3} sm={4} xs={6}>
						<ButtonGroup>
							<Button
								sx={{ color: "black" }}
								aria-label='reduce'
								onClick={() => {
									setWheelchairCount(Math.max(wheelchairCount - 1, 0));
								}}>
								<RemoveIcon fontSize='small' />
							</Button>
							<Button sx={{ color: "black" }} variant='outlined'>
								{" "}
								{wheelchairCount}
							</Button>
							<Button
								sx={{ color: "black" }}
								aria-label='increase'
								onClick={() => {
									setWheelchairCount(wheelchairCount + 1);
								}}>
								<AddIcon fontSize='small' />
							</Button>
						</ButtonGroup>
					</Grid>
					<Grid item md={3} sm={4} xs={6}>
						<ListItemIcon>
							<Checkbox
								icon={
									<Button
										style={{ backgroundColor: "transparent" }}
										sx={{
											px: 2,
											py: 1,
											bgcolor: "#EAECEE",
											color: "black",
											fontWeight: "bold",
											border: "1px solid",
										}}
										variant='contained'>
										Select
									</Button>
								}
								checkedIcon={
									<Button
										className='activeButtonColor'
										sx={{ px: 2, py: 1 }}
										variant='contained'>
										<CheckIcon sx={{ mr: 0.7 }} /> Select
									</Button>
								}
								checked={wheelchair}
								onChange={wheelchair1}
							/>
						</ListItemIcon>
					</Grid>
				</Grid>
			</ListItemButton>
			<Divider sx={{ my: 1.5 }} />
			<ListItemButton
				button
				disableRipple
				disableTouchRipple
				disablefocusribble='true'>
				<Grid container spacing={2} sx={{ alignItems: "center" }}>
					<Grid item md={6} sm={4} xs={12}>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								textAlign: "left",
							}}>
							<Typography variant='h6'>Car Seat</Typography>
						</Box>
					</Grid>
					<Grid item md={3} sm={4} xs={6}>
						<ButtonGroup>
							<Button
								sx={{ color: "black" }}
								aria-label='reduce'
								onClick={() => {
									setcarSeatCount(Math.max(carSeatCount - 1, 0));
								}}>
								<RemoveIcon fontSize='small' />
							</Button>
							<Button sx={{ color: "black" }} variant='outlined'>
								{" "}
								{carSeatCount}
							</Button>
							<Button
								sx={{ color: "black" }}
								aria-label='increase'
								onClick={() => {
									setcarSeatCount(carSeatCount + 1);
								}}>
								<AddIcon fontSize='small' />
							</Button>
						</ButtonGroup>
					</Grid>
					<Grid item md={3} sm={4} xs={6}>
						<ListItemIcon>
							<Checkbox
								icon={
									<Button
										style={{ backgroundColor: "transparent" }}
										sx={{
											px: 2,
											py: 1,
											bgcolor: "#EAECEE",
											color: "black",
											fontWeight: "bold",
											border: "1px solid",
										}}
										variant='contained'>
										Select
									</Button>
								}
								checkedIcon={
									<Button
										className='activeButtonColor'
										sx={{ px: 2, py: 1 }}
										variant='contained'>
										<CheckIcon sx={{ mr: 0.7 }} /> Select
									</Button>
								}
								checked={carSeat}
								onChange={carSeat1}
							/>
						</ListItemIcon>
					</Grid>
				</Grid>
			</ListItemButton>
			<Button
				onClick={saveAndGo}
				className='buttonColor'
				variant='contained'
				sx={{ py: 1.7, mt: 2 }}>
				Update Booking
			</Button>
		</div>
	);
};

export default ExtraOptions;
